import { LucideIcon } from 'lucide-react'

interface StatCardProps {
  title: string
  value: number | string
  icon: LucideIcon
  color?: string
  subtitle?: string
}

export default function StatCard({ title, value, icon: Icon, color = '#6366f1', subtitle }: StatCardProps) {
  return (
    <div
      className="rounded-xl p-6 flex items-start gap-4"
      style={{ background: '#252836', border: '1px solid #2d3148' }}
    >
      <div
        className="rounded-lg p-3 flex items-center justify-center"
        style={{ background: `${color}20` }}
      >
        <Icon size={22} style={{ color }} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-3xl font-bold text-white mb-1">{value}</div>
        <div className="text-sm font-medium" style={{ color: '#9ca3af' }}>{title}</div>
        {subtitle && (
          <div className="text-xs mt-1" style={{ color: '#6b7280' }}>{subtitle}</div>
        )}
      </div>
    </div>
  )
}
